import { useState } from 'react';

import { usePref } from '../../utils/use-pref';

import { THEME_ONBOARDING_VIEWED_KEY } from './theme-selector-onboarding';
import {
  ThemeSpotlightState,
  UseThemeOnboardingProps,
} from './theme-selector.types';

const THEME_ONBOARDING_VIEWED = 'viewed';

export const isThemeOnboardingActive = (state: ThemeSpotlightState | null) => {
  if (state === null) {
    return false;
  }
  return state.activeSpotlight !== null;
};

export const useThemeOnboardingState = ({
  callback,
}: UseThemeOnboardingProps): ThemeSpotlightState | null => {
  const [seen, updatePref, isLoading] = usePref(
    THEME_ONBOARDING_VIEWED_KEY,
    false
  );
  const [activeSpotlight, setActiveSpotlight] = useState<null | number>(0);

  if (seen === THEME_ONBOARDING_VIEWED || isLoading) {
    return null;
  }

  const back = () => {
    callback();
    setActiveSpotlight((activeSpotlight || 1) - 1);
  };

  const next = () => {
    callback();
    setActiveSpotlight((activeSpotlight as number) + 1);
  };

  const end = () => {
    updatePref(THEME_ONBOARDING_VIEWED);
    setActiveSpotlight(null);
  };

  return { next, back, end, activeSpotlight };
};
